import { Box, BoxProps, Button, Flex, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import { IMAGE_PATH, TEXT_SHADOW } from "../const";
import { SearchFilterForm } from "../forms/SearchFilterForm";
import { useRef } from "react";

export const FirstPageHeader: React.FC<BoxProps> = (props) => {
  const showBreak = useBreakpointValue({ base: false, md: true });

  // We show the form here on medium and up
  // On smaller screens it is placed under the header instead
  const showFilterForm = useBreakpointValue({ base: false, md: true });

  const buttonRef = useRef<HTMLButtonElement>(null);

  const scrollToButton = () => {
    if (buttonRef.current) {
      buttonRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box boxSize="100%" textAlign="center" px={2} {...props}>
      <Flex
        h={{ base: "85%", md: "60%", lg: "85%" }}
        flexDir="column"
        justify="center"
        color="white"
        gap={{ base: 8, md: 4 }}
        px={4}
        lineHeight="normal"
        textShadow={TEXT_SHADOW}
      >
        <Image src={`${IMAGE_PATH}/header.svg`} h={{ base: "150px", md: "200px" }} />
        <Image src={`${IMAGE_PATH}/bf-sun-icn-2.svg`} h="50px" />
        <Text fontSize={{ base: "25px", md: "35px" }} fontWeight="bold" textShadow="0px 1px 4px #000">
          Search Caravan Holiday Homes for Sale
          {showBreak ? <br /> : " "}at Holiday Parks across the UK
        </Text>
      </Flex>

      {showFilterForm ? (
        <SearchFilterForm mt="auto" />
      ) : (
        <Button
          variant="yellow"
          ref={buttonRef}
          gridColumn={{ base: "1 / -1", lg: "auto" }}
          fontWeight="bold"
          borderRadius="20px"
          borderColor="gray.200"
          borderWidth="1px"
          mt="auto"
          width="200px"
          scrollMarginTop="80px"
          onClick={scrollToButton}
        >
          Search Now
        </Button>
      )}
    </Box>
  );
};
